import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoubleCheckmark2"><Path d="M19.2988 4.59375L7.66309 20.3164L0.697266 14.8457L1.62305 13.666L7.375 18.1836L18.0938 3.70117L19.2988 4.59375Z" fill="currentColor"/><Path d="M23.2988 4.59375L11.6758 20.2988L10.4707 19.4062L22.0928 3.70117L23.2988 4.59375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark2;
